// @flow
import React from 'react';

import { selectors as countryConfigSelectors } from '@rover/react-lib/redux/ducks/countryConfiguration.duck';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/redux/ducks/frontendConfiguration.duck';

import Connect from '@rover/react-lib/components/utils/Redux/Connect';

import IntlPhoneInput from '@rover/react-lib/components/formFields/IntlPhoneInput';

import { type ContainerProps } from './container.constants';

const selector = state => ({
  supportedCountryCodes: countryConfigSelectors.getCountryCodes(state),
  locale: frontendConfigurationSelectors.getLanguage(state),
  countryCode: countryConfigSelectors.getCurrentCountryCode(state),
});

type Props = ContainerProps<
  typeof IntlPhoneInput,
  {
    onChange: (string, boolean) => void,
  }
>;

const IntlPhoneInputContainer = (props: Props) => (
  <Connect selector={selector}>
    {({ dispatch, ...connectedProps }) => <IntlPhoneInput {...connectedProps} {...props} />}
  </Connect>
);

export default IntlPhoneInputContainer;



// WEBPACK FOOTER //
// ../react-lib/src/containers/IntlPhoneInputContainer.jsx